export default "__VITE_ASSET__DUx0kMKl__"